import auth from "../../const/auth";
import netcoServer from '../../apis/netcoServer';
import {BASIC_REGISTRATION, INFO_SHOW} from "../types";
import handleResponse from '../helpers/handleResponse';
import infoPayload from "../helpers/payloadHandlers/infoPayload";
import checkBasicAuthentication from "./checkBasicAuthentication";
import _ from 'lodash';
import loadingCall from "../helpers/loadingCall";

const basicRegistration= (formValues) => async (dispatch, getState) => {
  if(formValues.password === formValues.password_confirmation) {
    let response = await loadingCall(dispatch, () => netcoServer.newPost('/UserService/basicRegistration', _.omit(formValues, ['redirect','uniqueID'])));
    handleResponse(dispatch, response, BASIC_REGISTRATION, data => onSuccessPayload(data, getState), '/', [() => checkBasicAuthentication(_.pick(formValues, ['userName', 'password','redirect','uniqueID','option','referenceNumber','authCode','createUser']))]);
  } else {
    dispatch({type: INFO_SHOW, payload: infoPayload('error', auth[getState().auth.language].passdontmatch)})
  }
};
const onSuccessPayload = (data, getState) => {
  return infoPayload('success', auth[getState().auth.language].registrationSuccessful);
};
export default basicRegistration;